<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-id
          exCollection="namingExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef"
          :doc="doc"
          :shared="false"
          :projectShared="false"
          :pid="true"
          :eid="$route.params.eid"
          :synced="false"
        >
          <template slot-scope="{ saveExercise, doc }">
            <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline">Naming Eco-System</h2>
              </v-col>
              <!-- <v-col cols="8" class="">
                <p
                  v-for="(item, index) in $t(
                    'exercise_structure.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col> -->
            </v-row>

            <v-row v-if="doc">
              <v-col cols="4">
                <v-card>
                  <v-card-title>
                    Document settings
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      label="Title"
                      v-model.trim="doc.title"
                      type="text"
                      required
                      :hide-details="false"
                      color="amber"
                    ></v-text-field>

                    <v-text-field
                      label="Master brand"
                      v-model.trim="doc.master"
                      type="text"
                      required
                      :hide-details="false"
                      color="amber"
                    ></v-text-field>

                    <v-select
                      label="Column width"
                      v-model.trim="doc.attrs.cols"
                      :items="['1', '2', '3', '4', '6', '12', 'auto']"
                    />

                    <v-select
                      label="Theme"
                      v-model.trim="doc.attrs.theme"
                      :items="['dark', 'light']"
                    />

                    <v-select
                      label="Type"
                      v-model.trim="doc.attrs.type"
                      :items="['large', 'medium', 'small', 'waterfall']"
                    />

                    <div class="d-flex justify-space-between">
                      <v-text-field
                        label="Prefix"
                        v-model.trim="doc.attrs.prefix"
                        type="text"
                        required
                        :hide-details="false"
                        color="amber"
                        placeholder="(Before or after name)"
                      ></v-text-field>

                      <v-select
                        v-if="doc.attrs.prefix"
                        label="Prefix position"
                        class="ml-4"
                        :items="[
                          'before',
                          'before-space',
                          'after',
                          'after-space',
                        ]"
                        v-model="doc.attrs.prefixPosition"
                      />
                    </div>

                    <div class="d-flex flex-wrap">
                      <v-switch
                        v-model="doc.attrs.controls"
                        label="Controls"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.attrs.note"
                        label="Description"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.attrs.details"
                        label="Details"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>

                      <v-switch
                        v-model="doc.edit"
                        label="Edit"
                        color="amber"
                        class="mr-3 ml-3"
                        inset
                      ></v-switch>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="8">
                <v-row>
                  <v-col cols="12">
                    <v-card light>
                      <v-card-title>
                        Add a new group
                      </v-card-title>
                      <v-card-text>
                        <div class="d-flex align-end justify-space-between">
                          <v-text-field
                            v-model="listName"
                            label="Page title"
                            :hide-details="true"
                            class="ma-0"
                            color="amber"
                            placeholder="Group name"
                          ></v-text-field>

                          <v-btn
                            @click="addList"
                            color="amber"
                            class="ma-0 ml-5"
                            light
                            >Add Section</v-btn
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <template v-if="doc.edit">
                    <v-col cols="4">
                      <div class="d-flex">
                        <unit-sub-items
                          v-model="doc.local.categories"
                          name="sub"
                        >
                          <v-label>Define the categories for each</v-label>
                          <p class="ma-0">
                            Type below and press <strong>Add</strong>
                          </p>
                        </unit-sub-items>
                      </div>
                    </v-col>

                    <v-col cols="4">
                      <div class="d-flex">
                        <unit-sub-items v-model="doc.local.websites" name="sub">
                          <v-label>Define the websites</v-label>
                          <p class="ma-0">
                            Type below and press <strong>Add</strong>
                          </p>
                        </unit-sub-items>
                      </div>
                    </v-col>

                    <v-col cols="4">
                      <div class="d-flex">
                        <unit-sub-items v-model="doc.local.assets" name="sub">
                          <v-label>Define the assets for each</v-label>
                          <p class="ma-0">
                            Type below and press <strong>Add</strong>
                          </p>
                        </unit-sub-items>
                      </div>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
            </v-row>

            <v-sheet :color="computedTheme" class="mt-4">
              <div class="pa-4">
                <v-row>
                  <v-col cols="12">
                    <div class="">
                      <draggable
                        :class="doc.cols === 'auto' ? 'auto' : 'row'"
                        group="outer"
                        :list="doc.list"
                        id="iso"
                      >
                        <structure-col
                          v-for="(item, index) in doc.list"
                          :key="`list-${index}`"
                          v-model="item.children"
                          :item="item"
                          :attrs="doc.attrs"
                          :local="doc.local"
                          class="iso-item"
                          @onChangeName="onChangeName"
                          @onChange="onChange"
                          @onEditList="onEditList"
                          @onDeleteList="onDeleteList"
                        ></structure-col>
                      </draggable>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-sheet>
            <v-row v-if="doc.allItems.length">
              <v-col cols="12">
                <h2 class="subtitle-2 mt-5 mt-5">Deleted items</h2>
                <div class="">
                  <structure-col
                    v-for="(item, index) in doc.allItems"
                    :key="`list-${index}-${item.id}`"
                    v-model="item.children"
                    :item="item"
                    :attrs="doc.attrs"
                    :local="doc.local"
                  ></structure-col>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <NamingLogos
                  v-if="doc"
                  :key="`logos-${doc.title}-${revision}`"
                  :id="`logos-${doc.title}-${revision}`"
                  :doc="doc"
                  class="mt-10"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <NamingSigns
                  v-if="doc"
                  :key="`signs-${doc.title}-${revision}`"
                  :id="`signs-${doc.title}-${revision}`"
                  :doc="doc"
                  class="mt-10"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <NamingWebsites
                  v-if="doc"
                  :key="`websites-${doc.title}-${revision}`"
                  :id="`websites-${doc.title}-${revision}`"
                  :doc="doc"
                  class="mt-10"
                />
              </v-col>
            </v-row>

            <bottom-navigation
              v-if="doc"
              :save="true"
              :next="false"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              :list="`naming-structure`"
              @save="saveExercise(true)"
              @prev="prevStep"
              @next="saveExercise(false)"
            >
            </bottom-navigation>
          </template>
        </exercise-logic-id>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicId } from "@/components/exercises";

import { UnitSubItems } from "@/components/units";

import draggable from "vuedraggable";

import {
  StructureCol,
  NamingLogos,
  NamingSigns,
  NamingWebsites,
} from "@/views/user/exercises/name-system";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserNameSystemId",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      iso: null,
      moveEl: null,
      moveList: null,
      dialogMode: "add",
      allItems: null,
      listName: "",
      test: false,
      revision: 1,
      doc: {
        cols: "4",
        list: [],
        allItems: [],
        title: "",
        master: "",
        edit: false,
        local: {
          categories: [],
          assets: [],
          websites: [],
        },
        attrs: {
          cols: 4,
          controls: true,
          theme: "light",
          type: "large",
          note: true,
          details: true,
          add: true,
          prefixPosition: "",
          prefix: "",
        },
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicId,
    StructureCol,
    UnitSubItems,
    NamingLogos,
    NamingSigns,
    NamingWebsites,
    draggable,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    computedWidth() {
      if (this.doc) {
        let unit = 50 / 10;
        return { width: `${unit * this.doc.cols}%` };
      } else {
        return null;
      }
    },
    computedTheme() {
      return this.doc.theme === "light" ? "grey lighten-4" : "grey darken-3";
    },
  },

  watch: {
    doc: {
      deep: true,
      handler() {
        this.revision++;
      },
    },
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      this.dialog = true;
      this.dialogMode = "save";
    },
    onLoadedRef(refs) {
      if (refs) {
        this.refs = refs[0];
      }
    },
    onLoadedEx(items) {
      // this.initIso();
      if (items) {
        this.mergeArrays(items[0].doc);
        if (items.length) {
          // this.doc.controls = items[0].doc.controls;
          // this.doc.note = items[0].doc.note;
        }
      }
    },
    onModifyEx(items) {
      if (items) {
        this.exercises = [...items];
      }
    },
    onSavedNext() {
      this.nextStep();
    },
    addList() {
      if (this.listName) {
        let lc = this.listName.replace(/\s/g, "").toLowerCase();
        this.doc.list.push({
          id: new Date().valueOf(),
          title: this.listName,
          name: lc,
          children: [],
        });
        this.listName = "";
      }
    },
    onChange() {
      console.log("revision", this.revision);
      this.revision++;
    },
    onChangeName(params) {
      const item = this.doc.list.find((x) => x.id === params.id);
      const indexOfItem = this.doc.list.indexOf(item);
      let lc = params.title.replace(/\s/g, "").toLowerCase();
      item.title = params.title;
      item.name = lc;
      this.$set(this.doc.list, indexOfItem, item);
      console.log("on change name", params, indexOfItem);
    },
    onDeleteList(params) {
      console.log("delete list");
      // loop through elements in list and re-distribute to master list
      let item = this.doc.list.find((x) => x.id === params.id);
      let index = this.doc.list.indexOf(item);
      this.cloneChildren(item);
      this.doc.list.splice(index, 1);
    },
    cloneChildren(item) {
      const items = [...item.children];
      this.doc.allItems.push({
        title: "Deleted Items",
        name: "deleted",
        children: items,
      });
    },
    onEditList(params) {
      let item = this.doc.list.find((x) => x.id === params.id);
      if (item) {
        let index = this.doc.list.indexOf(item);
        item = {
          ...params,
        };
        this.$set(this.doc.list, index, item);
      }
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      if (this.doc) {
        Object.entries(arr).forEach(([outerKey, value]) => {
          if (typeof value === "object") {
            Object.entries(value).forEach(([key, value]) => {
              this.doc[outerKey][key] = value;
            });
          }
          if (typeof value === "string") {
            this.doc[outerKey] = value;
          }
          if (typeof value === "boolean") {
            this.doc[outerKey] = value;
          }
        });
      } else {
        this.doc = arr;
      }
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
  },
};
</script>

<style lang="scss">
.auto {
  display: flex;
  flex-wrap: nowrap;
  .col-auto {
    width: auto;
    flex: 1;
  }
}</style
>./UserOfferSystemId.vue
